import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';

export const Wrapper = withStyles(Box, ({ spacing }: Theme) => ({
  root: {
    textAlign: 'left',
    marginBottom: spacing(2),
    position: 'relative',
  },
}));

export const Title = withStyles(Typography, ({ palette, spacing }: Theme) => ({
  root: {
    color: palette.text.primary,
    display: 'inline',
    marginBottom: spacing(1),
  },
}));

export const OptionalTag = withStyles(Typography, ({ palette, spacing }: Theme) => ({
  root: {
    color: palette.text.secondary,
    fontStyle: 'italic',
    margin: spacing(0, 2),
  },
}));

export const AdornmentWrapper = withStyles(Box, () => ({
  root: {
    display: 'flex',
  },
}));
